import React, { useEffect } from "react";
import logoCCM from '../../../assets/images/CCM_LOGO.png'
import packageJson from '../../../../package.json'
import ContenedorAlertas from "./ContenedorAlertas";
import ContenedorOperatividad from "./ContenedorOperatividad";
import ContenedorOperatividadTotal from "./ContenedorOperatividadTotal";
import SkeletonGraficoBarras from "./SkeletonGraficoBarras";

const DashboardPrincipal = () => {
  const version = packageJson.version

	return (
		<>
			{/* NUEVA VERSION DASHBOARD */}
			<section className="w-full h-full relative grid grid-rows-[40%_1fr] gap-5">
				<div style={{backgroundImage: `url(${logoCCM})`}} className="bg-no-repeat bg-center"></div>
				<div className="grid grid-cols-2 gap-2">
					<div className="flex flex-col text-center">
						<span className="font-bold text-xl">Alertas por empresa</span>
						<div className="flex-grow">
							<ContenedorAlertas></ContenedorAlertas>
						</div>
					</div>
					<div className="flex flex-col text-center">
						<span className="font-bold text-xl">Operatividad por empresa</span>
						<div className="flex-grow">
							<ContenedorOperatividad></ContenedorOperatividad>
						</div>
					</div>
				</div>
			</section>

			{/* VERSION ANTERIOR DASHBOARD */}
			{/* <section className="w-full h-full relative">
				<div style={{backgroundImage: `url(${logoCCM})`}} className="w-full h-full opacity-25 absolute top-0 left-0 bg-no-repeat bg-center"></div>
				<div className="grid grid-rows-[auto_1fr_1fr] w-full h-full gap-2">
					<div className="w-full border rounded-md text-center py-4">
						<legend className="text-blue-600 font-bold text-2xl">INDICADORES</legend>
					</div>
					<div className="w-full flex">
						<div className="w-1/2 h-full flex flex-col text-center">
							<span className="font-bold text-xl">Operatividad por empresa</span>
							<div className="flex-grow">
								<ContenedorOperatividad/>
							</div>
						</div>
						<div className="w-1/2 h-full flex flex-col text-center">
							<span className="font-bold text-xl">Alertas por empresa</span>
							<div className="flex-grow">
								<ContenedorAlertas/>
							</div>
						</div>
					</div>
					<div className="w-full">
						<ContenedorOperatividadTotal/>
					</div>
				</div>
			</section> */}
		</>
		
	)
}

export default DashboardPrincipal